import { Box, Chip, TextField, Typography, useMediaQuery } from "@mui/material";
import React, { useState } from "react";

import Logo from "../../../images/LOGO.svg";
import logoTitle from "../../../images/LOGO_Title.svg";
import ChipBtn from "../../UI/Chip/Chip";
import { useNavigate } from "react-router-dom";
import { useUserStore } from "../../../store/UserStore";
import { calculateTrialDaysLeft, convertDate } from "../../../utils/commonFunc";

const Login = () => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const user = useUserStore((state) => state.user);
  const setUser = useUserStore((state) => state.setUser);

  const smallerThan1064 = useMediaQuery("(min-width:1064px");
  const smallerThan925 = useMediaQuery("(min-width:925px");
  const smallerThan650 = useMediaQuery("(min-width:650px");

  //end point
  const api_endpoint = "https://rawdat.ai/login/portal";

  const loginClickHandler = async () => {
    if (userId.trim().length === 0) {
      setError("User ID is required");
      return;
    }

    if (password.trim().length === 0) {
      setError("Password is required");
      return;
    }

    try {
      const formData = JSON.stringify({ userId, password });

      const response = await fetch(api_endpoint, {
        method: "POST",
        body: formData,
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        const data = await response.json();

        if (data?.userId) {
          setUser(data);
          if (data.paidstatus === 1) {
            localStorage.setItem("rawdat-session", data.activationdate);
            navigate("/serverless-computing");
          } else {
            let daysLeft = calculateTrialDaysLeft(data.activationdate);
            if (daysLeft >= 0) {
              localStorage.setItem("rawdat-session", data.activationdate);
              navigate("/serverless-computing");
            } else {
              setError(
                "Your trial has expired. Please contact us for more information."
              );
            }
          }
        }
      } else {
        setError("Invalid username or password");
      }
    } catch (error) {
      console.error("Not able to login with the given credentials");
      setError("Oops! Something went wrong. Please contact us");
    }
  };

  return (
    <Box
      sx={{
        height: "calc(100lvh - 80px)",
        overflow: "hidden",
        background: "linear-gradient(180deg, #000 38%, #1D6BAE 100%);",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "1.5rem",
      }}
    >
      <Box
        sx={{
          maxWidth: "1440px",
          margin: "0 auto",
          display: "flex",
          gap: smallerThan1064 ? "8rem" : "3rem",
          alignItems: "center",
        }}
      >
        {smallerThan925 && (
          <Box
            sx={{
              width: "35%",
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              marginTop: "-7rem",
            }}
          >
            <img src={Logo} alt={"RAWDAT"} width={250} />
            <img src={logoTitle} alt={"RAWDATAI"} width={250} />
          </Box>
        )}

        <Box
          sx={{
            width: smallerThan650 ? "567px" : "100%",
            padding: "48px",
            display: "flex",
            flexDirection: "column",
            gap: "36px",
            backgroundColor: "#fff",
            border: `1px solid #888`,
            borderRadius: "8px",
            marginTop: "-7rem",
          }}
        >
          <Typography variant="h4" textAlign={"center"}>
            Log in to your account
          </Typography>
          <TextField
            variant="outlined"
            label={"User ID"}
            name={"userid"}
            value={userId}
            onChange={(e) => {
              setError("");
              setUserId(e.target.value);
            }}
            required
          />
          <TextField
            variant="outlined"
            label={"Password"}
            name={"password"}
            type="password"
            value={password}
            onChange={(e) => {
              setError("");
              setPassword(e.target.value);
            }}
            required
          />

          <Typography
            variant="body1"
            sx={{
              color: "titleColor.main",
              cursor: "pointer",
              textAlign: "center",
            }}
            onClick={() => navigate("/reset")}
          >
            Reset your password
          </Typography>

          <Chip
            variant={"filled"}
            color="primary"
            label={"Sign in"}
            sx={{ width: "100%", cursor: "pointer", height: "40px" }}
            onClick={loginClickHandler}
          />

          {!!error && (
            <Typography
              variant="body1"
              sx={{
                color: "error.main",
                textAlign: "center",
              }}
            >
              {error}
            </Typography>
          )}

          <Typography
            variant="body1"
            sx={{
              textAlign: "center",
            }}
          >
            Not a member?{" "}
            <span
              style={{
                color: "#0071ba",
                cursor: "pointer",
                /*  fontFamily: "Roboto", */
              }}
              onClick={() => navigate("/subscribe")}
            >
              Start a 7 day free trial
            </span>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Login;
